<template>
  <el-dialog
      :visible.sync="visible"
      title="成品/配件发货"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="凭证照片：" prop="imgs" style="margin-bottom: 0;">
            <MultipleImageUpload v-model="dataForm.imgs"></MultipleImageUpload>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="table-bar" style="margin:0;justify-content: flex-start;">
        <div class="bar-item">
          <el-radio-group v-model="receiverType" @change="receiverTypeChanged">
            <el-radio label="harbour" v-if="showHarbour">港口</el-radio>
            <el-radio label="factory">工厂</el-radio>
          </el-radio-group>

        </div>

        <el-select size="mini" v-model="company.id" v-if="receiverType==='factory'" @change="factoryChanged"
                   style="width: 200px;" class="bar-item" :filterable="true">
          <el-option
              v-for="item in factoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
          </el-option>
        </el-select>
        <dict-dropdown :value="company.id" size="mini" dictName="harbour"
                       v-if="receiverType==='harbour'"
                       :default-item="null"
                       style="width: 200px;"
                       :filterable="true" class="bar-item"
                       @changed="harbourChanged"></dict-dropdown>
        <el-button type="primary" class="bar-item" size="mini" @click="add2ReceiverList({ id: company.id, name: company.name })">添加收货方</el-button>
        <div class="bar-item" style="color: red;">出口发票由业务员统一录入</div>
      </div>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500">
        <el-table-column label="订单编号" prop="orderCode" align="center" width="180" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="品番号" prop="product.code" align="center">
          <template #default="{row}">
            <ProductRowCard :product="row.product"></ProductRowCard>
          </template>
        </el-table-column>
        <el-table-column label="计划数" prop="planCount" align="center" width="100"></el-table-column>
        <el-table-column label="已发货" prop="totalSendCount" align="center" width="100"></el-table-column>
        <el-table-column
            v-for="r in receiverList"
            :key="r.id"
            :label="r.name"
            header-align="center"
            align="center"
            width="120"
        >
          <template v-slot:header>
            <div style="display: flex;justify-content: space-between;align-items: center">
              <div>{{ r.name }}</div>
              <i class="el-icon-error" @click="removeReceiver(r)" style="cursor: pointer;margin-left: 6px;"></i>
            </div>
          </template>
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.'+r.id"
                :rules="detailRule.count"
                label-width="0"
            >
              <el-input v-model="scope.row[r.id]" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="发货时间" prop="planCount" align="center" width="160">
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.operateTime'"
                :rules="detailRule.operateTime"
                label-width="0"
            >
              <el-date-picker
                  v-model="scope.row.operateTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择时间"
                  size="mini"
                  style="width: 140px;"
              >
              </el-date-picker>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column
            label="备注"
            header-align="center"
            align="center"
            width="120"
        >
          <template v-slot="scope">
            <el-form-item
                :prop="'detailList.' + scope.$index + '.remark'"
                label-width="0"
            >
              <el-input v-model="scope.row.remark" size="mini"></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="dataFormSubmitHandle">确认发货</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 成品发货弹窗
 */
import DictDropdown from '@/components/DictDropdown/index.vue'
import debounce from 'lodash/debounce'
import MultipleImageUpload from '@/components/MultipleImageUpload'
import { countValidator, moneyValidator } from '@/utils/validate'
import ProductRowCard from '@/components/ProductRowCard.vue'
import FactoryDrop from '@/views/modules/trade/common/FactoryDrop/index.vue'

export default {
  components: { DictDropdown, FactoryDrop, ProductRowCard, MultipleImageUpload },
  data () {
    return {
      visible: false,
      dataForm: {},
      receiverList: [],
      company: { id: '', name: '' },
      factoryList: [],
      receiverType: 'factory',//收货方类型，harbour：港口，factory：工厂
    }
  },
  computed: {
    showHarbour(){
      let currentUser = this.$store.state.user
      if (currentUser.roleIdList.find(r => r === this.$const.roleKeys.Company)) {
        return false
      }
      return true
    },
    detailRule () {
      return {
        count: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: countValidator,
            trigger: 'change',
          },
        ],
        price: [
          {
            required: false,
            message: this.$t('validate.required'),
            trigger: 'change',
          },
          {
            validator: moneyValidator,
            trigger: 'change',
          },
        ],
        operateTime: [
          {
            required: false,
            message: this.$t('validate.required'),
            trigger: 'change',
          },]
      }
    },
    dataRule () {
      return {}
    }
  },
  methods: {
    loadFactoryList () {
      this.$http.get(`/trade/company/list`).then(({ data: res }) => {
        this.factoryList = res.data
      })
    },
    receiverTypeChanged () {
      this.dataForm.detailList.forEach(row => {
        this.receiverList.forEach(r => {
          delete row[r.id]
        })
      })
      this.receiverList = []
      this.company = { id: '', name: '' }
    },
    //工厂下拉列表
    factoryChanged (e) {
      let f=this.factoryList.find(item=>item.id===e)
      if(!f){
        this.company={ id:'',name:''}
      }else{
        this.company = { id: f.id, name: f.name }
      }
    },
    //港口下拉列表
    harbourChanged (e) {
      this.company = {id:e.dictValue,name:e.dictName,type:'hhh'}
    },
    removeReceiver(receiver){
      for(let i=this.receiverList.length-1;i>=0;i--){
        if(this.receiverList[i].id===receiver.id){
          this.receiverList.splice(i,1)
        }
        this.dataForm.detailList.forEach(row=>{
          if(row[receiver.id]){
            delete row[receiver.id]
          }
        })
        }
    },
    add2ReceiverList (data) {
      if (this.receiverList.find(r => r.id === data.id)) {
        return
      }
      data.name = this.$c.companyName(data.name)
      this.receiverList.push(data)
      this.dataForm.detailList.forEach(row => {
        if (row[data.id]) {
          return
        }
        this.$set(row, data.id, 0)
      })
    },
    init (detailList) {
      this.loadFactoryList()
      //提取收货方清单
      this.receiverList = []
      this.dataForm = {
        id: this.dataForm.id,
        remark: '',
        imgs: '',
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    // 表单提交
    dataFormSubmitHandle:
        debounce(
            function () {
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }
                if (this.$c.isArrayEmpty(this.receiverList)) {
                  this.$c.error('请添加收货方')
                  return false
                }
                let postForm = []
                this.dataForm.detailList.forEach(row => {
                  this.receiverList.forEach(r => {
                    if (!row[r.id] || row[r.id] == 0) {
                      return
                    }
                    postForm.push({
                      sourceType: 'make',
                      senderId: row.senderId,
                      sourceId: row.sourceId,
                      sourceTable: row.sourceTable,
                      productId: row.product.id,
                      sendCount: row[r.id],
                      receiverId: isNaN(parseInt(r.id.substring(0, 3))) ? '' : r.id,
                      receiverName: r.name,
                      operateTime: row.operateTime,
                      sendRemark: row.remark,
                      totalAmount: row.totalAmount,
                      sendImgs: this.dataForm.imgs,
                    })
                  })
                })
                if (postForm.length === 0) {
                  return this.$message.error('请设置合适的发货数量')
                }
                this.loading = true
                this.$api2
                    .post('/trade/factorystorelog/send', postForm)
                    .then(res => {
                      this.loading = false
                      this.$c.success('保存成功').then(() => {
                        this.visible = false
                        this.$emit('change')
                      })
                    })
                    .catch((e) => {
                      this.loading = false
                    })
              })
            },
            1000,
            { leading: true, trailing: false }
        )
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
